import React, { memo } from 'react';
import { Field, reduxForm } from 'redux-form';

import * as rules from '../../../../../common/services/ValidationRules';
import { isOnlyMobile } from '../../../../../common/services/isMobile';
import RenderInput from '../../../../../common/components/Form/RenderInput';
import { Dialog } from '../../../../../common/components/Dialog/Dialog';
import Button from '../../../../../common/components/Button/Button';

function SearchPresetForm({ handleSubmit }) {
  return (
    <div className="modal-inner">
      <form className="search-preset-form" onSubmit={handleSubmit}>
        <Field name="name" label="Name" component={RenderInput} required validate={[rules.required]} fullWidth={!isOnlyMobile} />
        <Field name="description" label="Description" component={RenderInput} fullWidth={!isOnlyMobile} />
      </form>
    </div>
  );
}

const SearchPresetFormWrapped = reduxForm({ form: 'search-preset' })(SearchPresetForm);

const SearchPresetDialog = memo(({ open, closePresetDialog, submitPresetDialog, addNewPreset }) => {
  const actions = [
    <Button key="cancel-btn" onClick={closePresetDialog}>
      Cancel
    </Button>,
    <Button key="submit-btn" onClick={submitPresetDialog}>
      Submit
    </Button>,
  ];

  const contentStyle = !isOnlyMobile
    ? {
        width: 255,
        overflowY: 'unset',
      }
    : null;

  return (
    <Dialog
      title="Save Filter"
      actions={actions}
      contentStyle={contentStyle}
      className="z-index-1300"
      modal
      open={open}
      onClose={closePresetDialog}
    >
      <SearchPresetFormWrapped onSubmit={addNewPreset} />
    </Dialog>
  );
});

export default SearchPresetDialog;
